import React from 'react';

import { AdminContentListPage } from './AdminBlogListPage';

const AdminNewsListPage = () => (
  <AdminContentListPage
    contentKey="/admin/content/news"
    routeKey="/admin/content/news"
    activeNavHref="/admin/content/news"
  />
);

export default AdminNewsListPage;
